import React from 'react'

import colors from '../../../assets/colors'
import consts from '../../../util/consts'

/**
 * Determina se um item é de coleta ou entrega.
 *
 * Regra: apenas itens cujo serviço é do tipo "na lavanderia"
 * (attendance_type_id === 1) possuem coleta/entrega. Dentre esses,
 * se já tiver etiqueta (bar_code) é uma entrega, caso contrário é coleta.
 *
 * @param {number|string} attendanceType valor de service.attendanceType (attendance_type_id)
 * @param {string|null} barCode etiqueta do item
 * @returns {'coleta'|'entrega'|null}
 */
export const getCollectType = (attendanceType, barCode) => {
  if (Number(attendanceType) !== consts.NA_LAVANDERIA) return null
  return barCode ? 'entrega' : 'coleta'
}

export const CollectTypeBadge = ({ type, variant = 'filled', style = {} }) => {
  if (!type) return null

  const isEntrega = type === 'entrega'
  const color = isEntrega ? colors.sucess : colors.secondary

  const variantStyle =
    variant === 'outlined'
      ? { color, backgroundColor: 'transparent', border: `1px solid ${color}` }
      : { color: '#FFF', backgroundColor: color }

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '1px 8px',
        borderRadius: '10px',
        fontSize: '10px',
        fontWeight: 700,
        lineHeight: '14px',
        whiteSpace: 'nowrap',
        ...variantStyle,
        ...style,
      }}
    >
      {isEntrega ? 'Entrega' : 'Coleta'}
    </span>
  )
}
